import {bootstrapApplication} from '@angular/platform-browser';
import {registerLocaleData} from '@angular/common';
import sk from '@angular/common/locales/sk';

import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';

import {init} from '@sentry/angular';
import {environment} from './environments/environment';

registerLocaleData(sk);

init({
  dsn: "https://0e5429e9658d9c4433a2b94c5fab953e@o557728.ingest.us.sentry.io/4508331209326592",
  environment: environment.sentryEnv,
  release: '1.0.3',
  enableTracing: false,
  enabled: environment.sentryEnabled
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
